import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { registerSW } from './services/sw-registration.js'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Register service worker after app render
registerSW({
  onUpdate: () => {
    // A new version is available. The user will be prompted
    // to reload via the app's update mechanism.
    console.log('New content available; please refresh.')
  },
  onSuccess: () => {
    console.log('Content cached for offline use.')
  },
})
